import { render } from "./ClinicModule.vue?vue&type=template&id=74a63efe&scoped=true"
import script from "./ClinicModule.vue?vue&type=script&lang=js"
export * from "./ClinicModule.vue?vue&type=script&lang=js"

import "./ClinicModule.vue?vue&type=style&index=0&id=74a63efe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74a63efe"

export default script